import { Component, Input } from '@angular/core';
import { CheckoutStore } from '@pepconnect/features/checkout/checkout.store';
import { CheckoutStepType } from '@pepconnect/features/checkout/enums/checkout-step-type.enum';
import { CheckoutTransaction } from '@pepconnect/features/checkout/models/checkout-transaction.model';

@Component({
  selector: 'app-pay-with-card-button',
  templateUrl: './pay-with-card-button.component.html'
})
export class PayWithCardButtonComponent {
  @Input() loading: boolean;
  @Input() transaction: CheckoutTransaction;

  constructor(protected checkoutStore: CheckoutStore) { }

  get buttonLabel() {
    return this.transaction.items[0].country.allowPaypalCheckout ? 'BUTTON_PAY_WITH_CC_OR_PAYPAL' : 'BUTTON_PAY_WITH_CC';
  }

  payWithCreditCard() {
    this.checkoutStore.setSelectedStep(CheckoutStepType.SavedCards);
  }
}
